// Global referral code handler plugin
// This plugin checks for referral codes in URL parameters and stores them in sessionStorage

const REFERRAL_CODE_KEY = 'referral_code'

export default {
  install(app, options) {
    // Function to extract referral code from URL
    const extractReferralCodeFromUrl = () => {
      if (typeof window === 'undefined') return null
      
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get('ref') || urlParams.get('referral') || urlParams.get('referral_code')
    }

    // Function to store referral code
    const storeReferralCode = (code) => {
      if (typeof window !== 'undefined' && code) {
        sessionStorage.setItem(REFERRAL_CODE_KEY, code)
        console.log('Referral code stored:', code)
      }
    }

    // Check for referral code on app mount
    const referralCode = extractReferralCodeFromUrl()
    if (referralCode) {
      storeReferralCode(referralCode)
    }

    // Make helper functions globally available
    app.config.globalProperties.$getReferralCode = () => {
      if (typeof window !== 'undefined') {
        return sessionStorage.getItem(REFERRAL_CODE_KEY) || ''
      }
      return ''
    }

    app.config.globalProperties.$clearReferralCode = () => {
      if (typeof window !== 'undefined') {
        sessionStorage.removeItem(REFERRAL_CODE_KEY)
      }
    }
  }
}
